import { render, staticRenderFns } from "./BmProspectosComentarios.vue?vue&type=template&id=70725ee3&"
import script from "./BmProspectosComentarios.vue?vue&type=script&lang=js&"
export * from "./BmProspectosComentarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports